import { cn } from '@/lib/utils';

interface LogoProps {
  className?: string;
  iconOnly?: boolean;
}

/** Geometric, modern wordmark that pairs an indigo→violet glyph with Inter. */
export function Logo({ className, iconOnly }: LogoProps) {
  return (
    <span
      className={cn('inline-flex items-center gap-2 font-semibold tracking-tight', className)}
    >
      <span
        className="grid h-7 w-7 place-items-center rounded-lg bg-gradient-to-br from-indigo-500 via-violet-500 to-fuchsia-500 text-white shadow-[var(--shadow-glow)]"
        aria-hidden="true"
      >
        <svg viewBox="0 0 24 24" className="h-4 w-4" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
          <path d="M5 7h14M12 7v12M7 13h10" />
        </svg>
      </span>
      {iconOnly ? null : <span className="text-base">Tally</span>}
    </span>
  );
}
